// ABOUTME: Trainings library icon showing columns/viewfinder pattern
// ABOUTME: Supports className, size, and color customization via stroke

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const TrainingsLibraryIcon = ({ className = "", size = 16, color = "currentColor" }: IconProps) => (
  <svg
    width={size}
    height={(size * 14) / 16}
    viewBox="0 0 16 14"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 10.75V3.25M5.75 10.75C5.75 11.1478 5.59196 11.5294 5.31066 11.8107C5.02936 12.092 4.64782 12.25 4.25 12.25H2.75C2.35218 12.25 1.97064 12.092 1.68934 11.8107C1.40804 11.5294 1.25 11.1478 1.25 10.75V3.25C1.25 2.85218 1.40804 2.47064 1.68934 2.18934C1.97064 1.90804 2.35218 1.75 2.75 1.75H4.25C4.64782 1.75 5.02936 1.90804 5.31066 2.18934C5.59196 2.47064 5.75 2.85218 5.75 3.25M5.75 10.75C5.75 11.1478 5.90804 11.5294 6.18934 11.8107C6.47064 12.092 6.85218 12.25 7.25 12.25H8.75C9.14782 12.25 9.52936 12.092 9.81066 11.8107C10.092 11.5294 10.25 11.1478 10.25 10.75M5.75 3.25C5.75 2.85218 5.90804 2.47064 6.18934 2.18934C6.47064 1.90804 6.85218 1.75 7.25 1.75H8.75C9.14782 1.75 9.52936 1.90804 9.81066 2.18934C10.092 2.47064 10.25 2.85218 10.25 3.25M10.25 10.75V3.25M10.25 10.75C10.25 11.1478 10.408 11.5294 10.6893 11.8107C10.9706 12.092 11.3522 12.25 11.75 12.25H13.25C13.6478 12.25 14.0294 12.092 14.3107 11.8107C14.592 11.5294 14.75 11.1478 14.75 10.75V3.25C14.75 2.85218 14.592 2.47064 14.3107 2.18934C14.0294 1.90804 13.6478 1.75 13.25 1.75H11.75C11.3522 1.75 10.9706 1.90804 10.6893 2.18934C10.408 2.47064 10.25 2.85218 10.25 3.25"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
